<template>
  <div class="bk-blokkli-item-options-range">
    <input v-model="text" type="range" :min="min" :max="max" :step="step" />
    <div>{{ formatted }}</div>
  </div>
</template>

<script setup>
import { computed } from "#imports";
const props = defineProps({
  label: { type: String, required: true },
  modelValue: { type: String, required: false },
  min: { type: Number, required: true },
  max: { type: Number, required: true },
  step: { type: Number, required: true }
});
const emit = defineEmits(["update:modelValue"]);
const text = computed({
  get() {
    return props.modelValue || "0";
  },
  set(v) {
    emit("update:modelValue", (v === void 0 ? "" : v).toString());
  }
});
const formatted = computed(() => {
  const numValue = typeof text.value === "string" ? Number.parseFloat(text.value) : text.value;
  const stepPrecision = (props.step.toString().split(".")[1] || "").length;
  return numValue.toFixed(stepPrecision);
});
</script>

<script>
export default {
  name: "OptionsFormRange"
};
</script>
